import React, { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Divider,
} from "@mui/material";
import { Tablecell } from "../../../component/Methods";

const SignalCurrentSummary = ({ strategies, strategyVal }) => {
  const [CombinedArray, setCombinedArray] = useState([]);

  useEffect(() => {
    // Only show data when we have a strategy selected
    if (strategyVal && strategies) {
      const strategy = strategies.find(
        (strategy) => strategy.strategyId === strategyVal
      );
      if (strategy && strategy.signals) {
        const { weights_keys, weights_values } = strategy.signals;
        const keys = Object.keys(weights_keys);
        const matchedKeys = keys.filter((key) =>
          weights_values?.hasOwnProperty(key)
        );

        if (matchedKeys.length > 0) {
          const count = matchedKeys.length;
          const sumOfMatchedValues = matchedKeys.reduce(
            (sum, key) => sum + parseFloat(weights_values[key] * 100),
            0
          );

          const positiveValuesSum = matchedKeys.reduce(
            (sum, key) =>
              weights_values[key] > 0
                ? sum + parseFloat(weights_values[key] * 100)
                : sum,
            0
          );

          const negativeValuesSum = matchedKeys.reduce(
            (sum, key) =>
              weights_values[key] < 0
                ? sum + parseFloat(weights_values[key] * 100)
                : sum,
            0
          );

          function roundit(number) {
            return number.toFixed(2).replace(/\.?0+$/, "");
          }

          const transformedArray = [
            { name: "Number of Signals in list", value: count },
            { name: "Long", value: roundit(positiveValuesSum) },
            { name: "Short", value: roundit(negativeValuesSum) },
            {
              name: "Gross Sum of Weights",
              value: roundit(positiveValuesSum - negativeValuesSum),
            },
            {
              name: "Net Sum of Weights",
              value: roundit(sumOfMatchedValues),
            },
          ];

          setCombinedArray(transformedArray);
        } else {
          setCombinedArray([]);
        }
      } else {
        setCombinedArray([]);
      }
    } else {
      // Clear data when no strategy is selected
      setCombinedArray([]);
    }
  }, [strategies, strategyVal]);

  const theme = useTheme();

  // Don't render anything if there's no strategy selected or no data
  if (!strategyVal || !strategies || CombinedArray.length === 0) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          border: `100px ${theme.palette.lightGrey.tableHeader}`,
          borderRadius: "4px",
          marginTop: "10px",
          width: "100%",
          marginRight: 1,
          minHeight: "120px",

        }}
      >

        <Table
          size="small"
          stickyHeader
          aria-label="a dense table"
          sx={{
            borderCollapse: "collapse",
            border: `1px solid ${theme.palette.divider}`,
            marginTop: "0px",
          }}
        >
          <TableBody>
            {CombinedArray?.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    background: theme.palette.grey[200],
                    cursor: "pointer",
                  },

                  backgroundColor: "transparent",
                }}
              >
                <Tablecell
                  align="left"
                  sx={{
                    fontWeight: "900",
                    fontSize: "12px",
                    paddingLeft: "5px",
                    color: theme.palette.text.primary,
                    borderRight: "none",
                    borderLeft: "none",
                    borderTop: "none",
                    borderBottom:
                      row.name == "Short"
                        ? `1px solid ${theme.palette.divider}`
                        : "none",
                  }}
                >
                  {row?.name}
                </Tablecell>

                <Tablecell
                  align="right"
                  sx={{
                    fontWeight: "500",
                    fontSize: "12px",
                    paddingLeft: "5px",
                    color: theme.palette.text.primary,
                    borderRight: "none",
                    borderLeft: "none",
                    borderTop: "none",
                    borderBottom:
                      row.name == "Short"
                        ? `1px solid ${theme.palette.divider}`
                        : "none",
                  }}
                >
                  {index === 0 ? row.value : `${row.value}%`}
                </Tablecell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
export default SignalCurrentSummary;
